import { useCallback } from 'react';
import { useSearchParams } from 'react-router';

/** The booking drawer opens on any page with ?booking=<id> (shareable, back button closes it). */
export const BOOKING_PARAM = 'booking';

export function useBookingDrawer() {
  const [params, setParams] = useSearchParams();
  const id = params.get(BOOKING_PARAM);
  const open = useCallback(
    (bookingId: string) => {
      setParams((p) => {
        const n = new URLSearchParams(p);
        n.set(BOOKING_PARAM, bookingId);
        return n;
      });
    },
    [setParams],
  );
  const close = useCallback(() => {
    setParams((p) => {
      const n = new URLSearchParams(p);
      n.delete(BOOKING_PARAM);
      return n;
    });
  }, [setParams]);
  return { id, open, close };
}
